<template>

    <simple-layout
        :indicators="[{'title': nbBases,}]"
        :models-loaded="true"
        name="Gestion des flottes"
        class="base-management"
    >
        <color-modal ref="color-modal"></color-modal>
        <div class="base-management-base">
            <div slot="loader"></div>
            <div slot="content">
                <h2>Flottes</h2>
                <ns-paginate
                    ref="basePaginate"
                    v-model="bases"
                    baseUrl="base/"
                    :filters="nsPaginateFilter"
                    :selectWitdh="{ xs: 24, sm: 24, md: 24, lg: 24, xl: 24 }"
                    :customFiltersToApply="customFiltersToApply"
                    :displayCsvButton="false"
                >
                    <div slot="list"
                         slot-scope="props"
                    >
                        <el-table
                            :data="props.list"
                            style="width: 100%"
                        >
                            <el-table-column
                                label="Nom"
                                prop="name"
                            >
                            </el-table-column>
                            <el-table-column
                                label="Nombre bases"
                            >
                                <template slot-scope="scope">
                                    {{fleetCount(scope.row)}}
                                </template>
                            </el-table-column>
                            <el-table-column
                                label="Configuration"
                                width="200px"
                            >
                                <template slot-scope="scope">

                                        <el-button
                                            v-tooltip.top="'Configurer couleurs'"
                                            type="primary"
                                            icon="ti-panel"
                                            @click="openColorModal(scope.row)"
                                        > Couleurs</el-button>

                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </ns-paginate>
            </div>
        </div>
    </simple-layout>
</template>

<script>

import NsPaginate from 'fundation-app-vuejs/src/components/partials/nsPaginate/index.vue';
import {mapGetters} from 'vuex';
import colorModal from '../../partials/color-modal.vue';
export default {

    components: {
        NsPaginate,
        colorModal
    },

    props: {

    },

    data (){
        return {
            nsPaginateFilter: [
                {
                    key: 'name',
                    verbose: 'Name'
                }
            ],
            bases: [],
        };
    },

    mounted(){

    },

    computed: {
        ...mapGetters('fundation', [
            'enableDownloadCsvGroups',
            'getVerbose'
        ]),
        // bases(){
        //     return this.$store.getters.bases;
        // },
        nbBases(){
            return this.bases.length;
        },
    },

    methods: {
        customFiltersToApply (){
            return {ordering: 'name'};
        },
        openColorModal(base) {
            this.$refs['color-modal'].open(base.uid);
        },
        fleetCount(base){
            return this.$store.getters.groups.filter(group=>{
                return group.base_uid === base.uid;
            }).length;
        }
    },
};
</script>

<style lang="scss">
    .base-management-base{

        .add-button {
            display: flex;
            margin-left: auto;
            margin-right: 30px;
        }
        .ti-plus{
            font-size: 11px;
            position: absolute;
            top: 5px;
            right: 12px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/page/Bases/Index.vue